import React, { useMemo } from "react"
import OrderBook from "components/organisms/orderBook"
import ClassNames from "classnames"
import { get } from "lodash"
import uuid from "uuid"

import { MenuPanel, Panel } from "components/organisms/panel"
import { APIResponse } from "redux/apis/types"
import { Future, Option } from "components/organisms/panel/future"
import MiddleChart from "components/molecules/chart/middleChart"
import { InfoTable, SignTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { label } from "components/organisms/panel/future"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { checkIsSp } from "utils/util"

type PropsType = {
  data: APIResponse.Res
  currentContent: number
  changeContent: Function
  changeDisplay: Function
  callSymbolDetail: Function
  refresh?: boolean
  setRefresh?: Function
  symbolDetail: APIResponse.Res
  underlyingAssetData: APIResponse.Res
}

const data: Array<{
  Index: number
  Price: number | null
  Qty: number | null
}> = [
  { Index: 1, Price: null, Qty: null },
  { Index: 2, Price: null, Qty: null },
  { Index: 3, Price: null, Qty: null },
  { Index: 4, Price: null, Qty: null },
  { Index: 5, Price: null, Qty: null },
]

export const FutureTemplate: React.FC<PropsType> = props => {
  const canvasId = useMemo(() => {
    return uuid()
  }, [])
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])

  const menuTab = [
    {
      id: 0,
      name: "先物",
      component: Future,
      componentProps: {
        data: props.data,
        canvasId: canvasId,
        changeDisplay: props.changeDisplay,
        callSymbolDetail: props.callSymbolDetail,
        symbolDetail: props.symbolDetail,
        underlyingAssetData: props.underlyingAssetData,
      },
    },
    {
      id: 1,
      name: "OP",
      component: Option,
      componentProps: {
        canvasId: canvasId,
        changeDisplay: props.changeDisplay,
        callSymbolDetail: props.callSymbolDetail,
        symbolDetail: props.symbolDetail,
        underlyingAssetData: props.underlyingAssetData,
        refresh: props.refresh,
      },
    },
  ]

  return (
    <MainContainer className="future-option-template right-thin-layout">
      <div className="contents-block">
        <MenuPanel
          menu={menuTab}
          className="panel-future"
          active={props.currentContent}
          changeMenu={(num: number) => {
            props.changeContent(num)
            props.changeDisplay(label[0].id)
          }}
          refresh={() => props.setRefresh(true)}
        />
      </div>

      {!isPhone && (
        <div
          className={ClassNames("contents-block", {
            "side-symbol-block": props.currentContent === menuTab[1].id,
          })}
        >
          <Panel className="panel-main-index" title="" nonePanelHeader={true}>
            <MiddleChart id={canvasId} />
            <InfoTable
              list={
                props.currentContent === menuTab[1].id
                  ? infoTableColumns.OP
                  : infoTableColumns.future
              }
              data={get(props.symbolDetail, "Symbol", {})}
              className="table-striped table-index-detail"
              wrapperCls="index-detail-table-row"
            />
            <OrderBook
              push={get(props.symbolDetail, "Symbol", {})}
              Symbol={get(props.symbolDetail, "Symbol", {})}
              length={5}
            />
          </Panel>
        </div>
      )}
    </MainContainer>
  )
}

type OpOnlyPropsType = {
  changeDisplay: Function
  callSymbolDetail: Function
  symbolDetail: APIResponse.Res
}

export const OpOnlyTemplate: React.FC<OpOnlyPropsType> = props => {
  const canvasId = useMemo(() => {
    return uuid()
  }, [])

  return (
    <MainContainer className="future-option-template right-thin-layout">
      <div className="contents-block">
        <Option
          changeDisplay={props.changeDisplay}
          canvasId={canvasId}
          callSymbolDetail={props.callSymbolDetail}
        />
      </div>
      <div className={"contents-block side-symbol-block"}>
        <Panel className="panel-main-index" title="" nonePanelHeader={true}>
          <MiddleChart id={canvasId} />
          <InfoTable
            list={infoTableColumns.OP}
            data={get(props.symbolDetail, "Symbol", {})}
            className="table-striped table-index-detail"
            wrapperCls="index-detail-table-row"
          />
          <SignTable buy={data} sell={data} />
        </Panel>
      </div>
    </MainContainer>
  )
}

type FutureOnlyPropsType = {
  data: APIResponse.Res
  changeDisplay: Function
  callSymbolDetail: Function
  symbolDetail: APIResponse.Res
}

export const FutureOnlyTemplate: React.FC<FutureOnlyPropsType> = props => {
  const canvasId = useMemo(() => {
    return uuid()
  }, [])

  return (
    <MainContainer className="future-option-template right-thin-layout">
      <div className="contents-block">
        <Future
          callSymbolDetail={props.callSymbolDetail}
          changeDisplay={props.changeDisplay}
          data={props.data}
          canvasId={canvasId}
        />
      </div>
      <div className={"contents-block"}>
        <Panel className="panel-main-index" title="" nonePanelHeader={true}>
          <MiddleChart id={canvasId} />
          <InfoTable
            list={infoTableColumns.future}
            data={get(props.symbolDetail, "Symbol", {})}
            className="table-striped table-index-detail"
            wrapperCls="index-detail-table-row"
          />
          <SignTable buy={data} sell={data} />
        </Panel>
      </div>
    </MainContainer>
  )
}
